<div id="kpi-echart"></div>

<ng-container *ngIf="chartData">
  <icon-with-label
    [uiType]="chartData.kpi.targetOperator === 'should_increase' ? 'more-is-better' : 'less-is-better'"
    [text]="(chartData.kpi.targetOperator === 'should_increase' ? 'more_is_better' : 'less_is_better') | localize | uppercase">
  </icon-with-label>
  <div
    class="popover-origin"
    #chartPopover="uiPopover"
    [uiContent]="popoverOptions.content"
    [ngStyle]="popoverOriginStyle"
    [uiBackdrop]="true"
    [uiPlacement]="popoverOptions.placement"
    [uiOverlayClassName]="popoverOptions.overlayClassName"
    uiTrigger="click"
    ui-popover></div>

  <ng-template #projectionFormTemplate>
    <kpi-projection-form
      [kpi]="chartData.kpi"
      [existingProjections]="chartData.projections"
      [projectionFormOpenedFrom]="projectionFormOpenedFrom"
      [projectionData]="projectionFormData"
      (hide)="chartPopover.hide()"></kpi-projection-form>
  </ng-template>

  <ng-template #pointMenuTemplate *ngIf="chartData.canManageKpis">
    <chart-point-menu [menuItems]="chartPointMenuItems"></chart-point-menu>
  </ng-template>
</ng-container>

<div class="empty-state" *ngIf="chartData && !chartData.snapshots.length && !chartData.projections.length" uiJustify="space-between">
  <div class="no-updates-label" ui-row uiJustify="center">{{ "no_updates_yet" | localize }}</div>
  <div class="action-buttons" *ngIf="!chartData.kpi.insightLink && chartData.canEditKpi" ui-row uiJustify="center">
    <button class="update-button" (click)="openSnapshotFormModal()" data-test-id="kpi-chart-update-kpi-button" ui-col ui-button uiType="default" uiShape="round">{{ "update" | localize }}</button>
    <button (click)="onAutomateClick()" data-test-id="kpi-chart-automate-kpi-button" ui-col ui-button uiType="primary" uiShape="round">{{ "automate" | localize }}</button>
  </div>
  <div class="sublabel" *ngIf="chartData.kpi.insightLink" ui-row uiJustify="center">{{ "the_chart_will_be_updated_next_data_sync" | localize }}</div>
</div>
